<script lang="ts">
  import { onMount } from "svelte"
  import { InboxWorkflowEngine } from "@kontextwerk/control-web-frame"
  import { type InboxWorkflowApiAdapter } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import {
    commitInboxCaseStep,
    fetchInboxCaseBatchWorkflowState,
    fetchInboxCaseStepPreview,
    type InboxStepCommitRequest,
    type InboxStepPreviewRequest,
  } from "../../../../../../../../api/kehrblatt/inbox-cases"
  import type { InboxCaseWorkflowOverlayProps } from "./_logic/contract"
  import { buildKehrblattInboxWorkflowRegistry } from "./registry"
  import { automaticLetterDeliveryAccessForOrganization } from "../../../../../../_shared/_logic/free-trial-experience"

  let {
    todos,
    organization = null,
    trialRestrictionsActive = false,
    actorIsAdmin = false,
    helpers = null,
    readOnly = false,
    onFinished = null,
    onremoveOverlay = null,
    onshowOverlay = null,
    setActionButtonSnippet = null,
  }: InboxCaseWorkflowOverlayProps = $props()

  const automaticLetterDeliveryAccess = $derived(
    automaticLetterDeliveryAccessForOrganization(organization, actorIsAdmin),
  )
  const registry = $derived(
    buildKehrblattInboxWorkflowRegistry({
      trialRestrictionsActive,
      automaticLetterDeliveryAllowed: automaticLetterDeliveryAccess.allowed,
      automaticLetterDeliveryDisabledReason: automaticLetterDeliveryAccess.disabledReason,
    }),
  )
  const apiAdapter: InboxWorkflowApiAdapter = {
    loadWorkflow: (payload, options = {}) =>
      fetchInboxCaseBatchWorkflowState(
        {
          flow_key: payload.flow_key,
          action_case_ids: payload.action_case_ids,
        },
        { organizationId: options.organizationId },
      ),
    commitStep: (flowKey, stepKey, payload, options = {}) =>
      commitInboxCaseStep(flowKey, stepKey, payload as InboxStepCommitRequest, {
        organizationId: options.organizationId,
      }),
    loadStepPreview: (flowKey, stepKey, payload, options = {}) =>
      fetchInboxCaseStepPreview(flowKey, stepKey, payload as InboxStepPreviewRequest, {
        organizationId: options.organizationId,
        signal: options.signal,
      }),
  }

  onMount(() => {
    onshowOverlay?.()
    setActionButtonSnippet?.(null)

    return () => setActionButtonSnippet?.(null)
  })
</script>

<InboxWorkflowEngine
  {todos}
  {organization}
  {helpers}
  {readOnly}
  {onFinished}
  {onremoveOverlay}
  {apiAdapter}
  {registry}
/>
